import { render, staticRenderFns } from "./schoolDetail.vue?vue&type=template&id=5457691c&"
import script from "./schoolDetail.vue?vue&type=script&lang=js&"
export * from "./schoolDetail.vue?vue&type=script&lang=js&"
import style0 from "./schoolDetail.vue?vue&type=style&index=0&id=5457691c&prod&lang=less&scpoed=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports